<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.magazines')" />
      <div class="d-flex" v-dragscroll style="overflow: auto">
        <v-col v-for="article in articles" :key="article.article_id" :xs="6" :sm="4" :md="3" :xl="2" :cols="6">
          <div
            class="center-cropped rounded-lg d-flex flex-column justify-center align-center pa-5"
            :class="{ 'article-active': $route.params.articleId == article.article_id, article: $route.params.articleId != article.article_id }"
            :style="{ backgroundImage: `url(${article.thumbnail})` }"
            @click="getArticle(article.article_id)"
          >
            <span class="white--text font-weight-medium text-center self-align-center ellipsis">{{ article.title }}</span>
          </div>
        </v-col>
      </div>
      <div class="mt-15">
        <v-row>
          <v-col :xs="12" :sm="6" :cols="12"><img class="rounded-1r w-100" :src="articleDetails.image" style="object-fit: cover" /></v-col>
          <v-col :xs="12" :sm="6" :cols="12">
            <div class="text-h4 font-weight-bold secondary--text mb-8">{{ articleDetails.title }}</div>
            <div v-html="desc"></div>
            <div class="text-h6 font-weight-bold secondary--text mt-6">{{ createdAt | shortDate }}</div>
          </v-col>
        </v-row>
      </div>
    </LayoutContent>
  </div>
</template>

<script>
import { PAGE } from '@/api'
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '../layouts/LayoutContent.vue'

export default {
  components: { LayoutContent, SectionTitle },
  data() {
    return {
      articles: [],
      articleDetails: {
        title: '',
        description: '',
        image: '',
        created_at: ''
      }
    }
  },
  created() {
    PAGE.getArticleList().then((res) => (this.articles = res.article))
    PAGE.getArticleDetails(this.$route.params.articleId).then((res) => (this.articleDetails = res))
  },
  computed: {
    createdAt() {
      if (this.articleDetails.created_at) {
        let d = new Date(this.articleDetails.created_at)
        let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
        let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d)
        let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
        return `${da} ${mo}, ${ye}`
      }
      return ''
    },
    desc() {
      if (this.articleDetails) return this.articleDetails.description.replace(/width: 705px;/g, 'width:100%;').replace(/width="640" height="360"/g, 'width:100%;')
      return ''
    }
  },
  methods: {
    getArticle(articleId) {
      PAGE.getArticleDetails(articleId).then((res) => (this.articleDetails = res))
      this.$router.replace({ name: this.$constants.ROUTE_NAME.ARTICLE_DETAIL, params: { articleId: articleId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.center-cropped {
  // width: 200px;
  height: 100px;
  background-position: center center;
  background-repeat: no-repeat;
  object-fit: cover;
  object-fit: scale-down;
  background-size: cover;
}
.article {
  box-shadow: inset 0 0 0 200px rgba(0, 0, 0, 0.5);
}
.article:hover {
  cursor: pointer;
  box-shadow: inset 0 0 0 200px rgba(116, 206, 0, 0.7);
}
.article-active {
  box-shadow: inset 0 0 0 200px rgba(12, 154, 82, 0.7);
}
.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  // height: 50px;
  word-break: normal;
}
</style>
